import React from "react";
import { Box, Grid, Skeleton, Paper } from "@mui/material";

const SandboxTableSkeleton = () => {
  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      {/* Top bar: search + buttons */}
      <Grid container justifyContent="space-between" alignItems="center" spacing={2} mb={2}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={40} width="60%" />
        </Grid>
        
      </Grid>

      {/* Table Header Skeleton */}
      <Grid container spacing={2} mb={1}>
        <Grid item xs={1}><Skeleton variant="text" width={20} /></Grid>
        <Grid item xs={4}><Skeleton variant="text" width="80%" /></Grid>
        <Grid item xs={4}><Skeleton variant="text" width="80%" /></Grid>
        {/* <Grid item xs={3}><Skeleton variant="text" width="40%" /></Grid> */}
      </Grid>

      {/* Table Rows Skeleton */}
      {[...Array(10)].map((_, idx) => (
        <Grid container spacing={2} key={idx} alignItems="center" mb={1}>
          <Grid item xs={1}><Skeleton variant="circular" width={20} height={20} /></Grid>
          <Grid item xs={4}><Skeleton variant="text" width="90%" height={25} /></Grid>
          <Grid item xs={4}><Skeleton variant="text" width="90%" height={25} /></Grid>
          
           
        
        </Grid>
      ))}
    </Paper>
  );
};

export default SandboxTableSkeleton;
